import { useMemo } from 'react';
import { useChatContext, Avatar } from 'stream-chat-react';
import moment from 'moment';
import Badge from '@mui/material/Badge';

import type { UserResponse } from 'stream-chat';

import type { StreamChatType } from '../../types';
import { useAdminPanelFormState } from './context/AdminPanelFormContext';
import { ListItem, ListItemAvatar, ListItemText } from '@mui/material';

const ListContainer = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const {errors, createChannelType} = useAdminPanelFormState()
  const showHeading = !createChannelType || createChannelType === 'team';
  return (
    <div className='user-list__container'>
      {showHeading && <h2><span>Channel Members</span></h2>}
      <div className='user-list__header user-list__row'>
        <div className='user-list__column-block'>
          <p>User</p>
        </div>
        <div className='user-list__column--checkbox'>
          <p>Status</p>
        </div>
      </div>
      {children}
    </div>
  );
};

type UserItemProps = {
  user: UserResponse<StreamChatType>;
};


const UserItem = ({ user }: UserItemProps) => {
  const title = user.name || user.id;
  return (
    <label htmlFor={user.id} title={title} className='user-list__row'>
      <div className='user-list__column-block'>
        <ListItem dense sx={{ paddingLeft: 0, paddingRight: 0 }}>
          <ListItemAvatar>
            <Avatar image={user.image} name={title} size={40} />
          </ListItemAvatar>
          <ListItemText primary={title} secondary={`Last seen ${moment(user.last_active).calendar()}`} secondaryTypographyProps={{ fontSize: `11px !important` }} />
        </ListItem>
      </div>
      <div className='user-list__column--checkbox'>
        <Badge color={user.online ? 'success' : 'secondary'} variant="dot">
          <p>{user.online ? 'online' : 'offline'}</p>
        </Badge>
      </div>
    </label>
  );
};


export const ChannelUsersList = () => {
  const { channel } = useChatContext<StreamChatType>();
  const members = useMemo(
    () => Object.values(channel?.state?.members ?? {}),
    [channel?.state?.members],
  );

  return (
    <ListContainer>
      {members.length === 0
        ? <div className='user-list__message'>No users found.</div>
        : members.map((member, index) => (
          <UserItem
            // Stream guarantees a user in the member object but guard for safety
            key={member.user?.id ?? `member-${index}`}
            user={member.user as UserResponse<StreamChatType>}
          />
        ))}
    </ListContainer>
  );
};
